export const SET_BILL_ACCEPTOR_BUSY = 'SET_BILL_ACCEPTOR_BUSY';
